const firebaseConfig = {
    apiKey: "AIzaSyAsNo9M0xH3wXzcF8AbxIO9JtRw8h55Ep8",
    authDomain: "clone-cf8cb.firebaseapp.com",
    projectId: "clone-cf8cb",
    storageBucket: "clone-cf8cb.appspot.com",
    messagingSenderId: "27268048821",
    appId: "1:27268048821:web:e2994d0b351223af805bfc",
    measurementId: "G-MJZ8LS6J3C"
};

export default  firebaseConfig;